import { Avatar, Button } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { UploadFilesIcon, UploadFilesPurpleIcon } from 'Images';
import { forwardRef } from 'react';
interface IUploadFileButton {
  clickHandler: () => void;
  children?: string;
  isDataRequired?: boolean;
  ariaLabel?: string;
  dataId?: string;
  additionalFileAttachment?: boolean;
  isFileError: boolean;
}
export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  IUploadFileButton
>((props, ref) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);
  const isDesktop = useIsDesktop();
  const dataId = props.dataId ? props.dataId : '';

  return (
    <Button
      aria-haspopup='dialog'
      aria-required={props.isDataRequired ? 'true' : 'false'}
      data-required={props.isDataRequired ? 'true' : 'false'}
      aria-invalid={props.isFileError}
      data-id={dataId}
      ref={ref}
      sx={
        isDesktop
          ? {
              minWidth: '130px',
              width: 'auto',
              fontSize: '20px',
              color: '#344266',
              backgroundColor: '#FBFCFF',
              borderRadius: '8px',
              padding: '4px 20px',
              '&:hover': { backgroundColor: '#FBFCFF' },
            }
          : {
              width: '100%',
              fontSize: '16px',
              color: '#344266',
              backgroundColor: '#fff',

              borderRadius: '8px',
              padding: '6px 16px',
              border: '1px solid #B7CCFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '12px',
              '&:hover': { backgroundColor: '#fff' },
            }
      }
      onClick={props.clickHandler}
      aria-label={dictionary.upload}
      endIcon={
        <Avatar
          alt=''
          src={isDesktop ? UploadFilesIcon : UploadFilesPurpleIcon}
          sx={{ width: '24px', height: '24px' }}
        />
      }
      tabIndex={props.dataId ? undefined : -1}
    >
      {props.children}
    </Button>
  );
});
